function responseArrayBuffer(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  return response.arrayBuffer();
}

export default function(input, init) {
  return fetch(input, init).then(responseArrayBuffer);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-fetch/src/buffer.js
// module id = 479
// module chunks = 0